/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'warning': {
    width: 18,
    height: 16,
    viewBox: '0 0 18 16',
    data: '<path pid="0" fill-rule="evenodd" clip-rule="evenodd" d="M10.922 1.038a2.297 2.297 0 00-3.933.148L.698 12.195l-.065.173a2.297 2.297 0 00.226 1.985l.097.141a2.298 2.298 0 001.724.92l.056-.002.033.003h12.525l.176-.015a2.3 2.3 0 001.67-1.047c.4-.627.47-1.41.191-2.098L11.008 1.18l-.085-.142zM9.508 11.333a.5.5 0 00-.5-.5l-.098.008a.5.5 0 00.098.992l.09-.008a.5.5 0 00.41-.492zM9 1c-.425 0-.82.208-1.064.555l-.076.12-6.265 10.956a1.298 1.298 0 00.998 1.77l.148.016.028-.002 12.5.001c.42-.022.802-.245 1.028-.6.197-.31.253-.687.177-.997l-.04-.128L10.136 1.67A1.298 1.298 0 009 1zm.492 4.577a.5.5 0 00-.992.09V9l.008.09A.5.5 0 009.5 9V5.667l-.008-.09z" _fill="#1F222C"/>'
  }
})
